// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__3atfx","inputSuccess":"FieldCurrencyInput_inputSuccess__Krpwb","inputError":"FieldCurrencyInput_inputError__3y0aj"};